<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="true"
      manageCorpName=""
      :isAdmin="true"
      :isDiagAvailablePlan="true"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="score"
      :diagItemsCountTotal="totalScore"
    ></DiagHeaderNavigation>

    <div class="l-contents" v-if="!isRendering">
      <DiagNavigation
        isAdmin=true
      ></DiagNavigation>
      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <p class="l-text">
            「監査の管理」では「監査フォーム」で「いいえ」「不明」と回答された項目に対して、対応期限や優先順などの設定を行うことができます。<br>
            また、クライアント法人が回答した項目について専門家ユーザーとして承認を行うことができます。
          </p>
        </div>
        <div class="l-diagnosisSearch">
          <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
            <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
            <div class="l-diagnosisSearch__selected">
              <dl>
                <dt v-if="!isIpo">リスク度</dt>
                <dd v-if="!isIpo">{{ selectedRiskLevelLabel }}</dd>
                <dt v-if="isIpo">IPO重要度</dt>
                <dd v-if="isIpo">{{ selectedIpoLevelLabel }}</dd>
                <dt>回答内容</dt>
                <dd>{{ selectedItemValsLabel }}</dd>
                <dt>確認状況</dt>
                <dd>{{ selectedVerifiedByLaborConsultantLabel }}</dd>
                <dt>カテゴリ</dt>
                <dd>{{ selectedDiagSectionLabel }}</dd>
              </dl>
            </div>
          </div>
          <transition name="diagmanagesearch-fade">
            <div class="l-diagnosisSearch__body" v-show="isSearch">
              <div class="l-diagnosisSearch__section" v-if="!isIpo">
                <label class="l-formGroup__label">リスク度</label>
                <ul class="l-inputList">
                  <li v-for="riskLevel in this.riskLevelList" :key="riskLevel.riskLevelId">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="riskLevel.riskLevelId"
                        v-model="searchForm.selectedRiskLevelIds" />
                      {{ riskLevel.name }}
                    </label>
                  </li>
                </ul>
              </div>

              <div class="l-diagnosisSearch__section" v-if="isIpo">
                <label class="l-formGroup__label">IPO重要度</label>
                <ul class="l-inputList">
                  <li v-for="ipoImportance in this.ipoImportanceList" :key="ipoImportance.ipoImportanceId">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="ipoImportance.ipoImportanceId"
                        v-model="searchForm.selectedIpoLevelIds" />
                      {{ ipoImportance.name }}
                    </label>
                  </li>
                </ul>
              </div>

              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">回答内容</label>
                <ul class="l-inputList">
                  <li v-for="itemVal in this.itemValList" :key="itemVal.value">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="itemVal.value"
                        v-model="searchForm.selectedItemVals" />
                      {{ itemVal.label }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="l-diagnosisSearch__section is-noboder">
                <label class="l-formGroup__label">確認状況</label>
                <ul class="l-inputList">
                  <li v-for="verifiedByLaborConsultant in this.verifiedByLaborConsultantList" :key="verifiedByLaborConsultant.value">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="verifiedByLaborConsultant.value"
                        v-model="searchForm.selectedVerifiedByLaborConsultant" />
                      {{ verifiedByLaborConsultant.label }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">カテゴリ</label>
                <ul class="l-inputList">
                  <li v-for="diagSection in this.diagSectionListForSearch" :key="diagSection.sectionId">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="diagSection.sectionId"
                        v-model="searchForm.selectedDiagSectionIds">
                      {{ diagSection.label }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="l-diagnosisSearch__bottom">
                <div class="btn-basic is-inlne" @click="search()"><a>チェックした項目で絞り込み</a></div>
              </div>
            </div>
          </transition>
        </div>
        <div class="l-paging__header">
          <div>
            <div class="all-edit">
              <div class="l-select">
                <select @change="execBulkUpdate()" v-model="bulkUpdateForm.bulkUpdateMode">
                  <option value="">選択した{{ selectedDiagResultItemCount }}件を一括変更</option>
                  <template v-for="bulkUpdateMode in bulkUpdateModeList">
                    <option :value="bulkUpdateMode.value" :key="bulkUpdateMode.value">
                      {{ bulkUpdateMode.label }}
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </div>
          <div>
            <div class="l-paging__setting">
              <p v-show="pageInfo.from && pageInfo.to">{{ pageInfo.from }} 〜 {{pageInfo.to}} / {{pageInfo.total}} 件</p>
              <p class="l-select__label">表示件数</p>
              <div class="l-select">
                <select v-model="perPage" @change="onChangePerPage()">
                  <option value="50">50件</option>
                  <option value="100">100件</option>
                  <option value="150">150件</option>
                  <option value="200">200件</option>
                  <option value="250">250件</option>
                  <option value="300">300件</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <table class="table-base audit-table table-select is-small">
          <colgroup>
            <col style="width: 20px;">
            <col style="width: 40%;">
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
          </colgroup>
          <thead>
            <tr class="is-sort">
              <th class="t-left"><input type="checkbox" class="js-allcheck" @click="changeIsAllChecked(!bulkUpdateForm.isAllChecked)"></th>
              <th class="t-left" @click="sortByCheckItem()" :class="{'is-sorted' : searchForm.sortKey.isSortedByCheckItem, 'is-descending' : (searchForm.sortKey.isSortedByCheckItem && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByCheckItem && searchForm.sortKey.isAscendingSort ) }">
                <span>項目名</span>
              </th>
              <th class="t-center" @click="sortByDiagSection()" :class="{'is-sorted' : searchForm.sortKey.isSortedByDiagSection, 'is-descending' : (searchForm.sortKey.isSortedByDiagSection && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByDiagSection && searchForm.sortKey.isAscendingSort ) }">
                <span>カテゴリ</span>
              </th>
              <th class="t-center" @click="sortByAnswer()" :class="{'is-sorted' : searchForm.sortKey.isSortedByAnswer, 'is-descending' : (searchForm.sortKey.isSortedByAnswer && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByAnswer && searchForm.sortKey.isAscendingSort ) }">
                <span>回答</span>
              </th>
              <th class="t-center" @click="sortByVerifiedByLaborConsultant()" :class="{'is-sorted' : searchForm.sortKey.isSortedByVerifiedByLaborConsultant, 'is-descending' : (searchForm.sortKey.isSortedByVerifiedByLaborConsultant && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByVerifiedByLaborConsultant && searchForm.sortKey.isAscendingSort ) }">
                <span>確認</span>
              </th>
              <th class="t-center" @click="sortByIsHighPriority()" :class="{'is-sorted' : searchForm.sortKey.isSortedByIsHighPriority, 'is-descending' : (searchForm.sortKey.isSortedByIsHighPriority && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByIsHighPriority && searchForm.sortKey.isAscendingSort ) }">
                <span>優先度</span>
              </th>
             <th v-if="!isIpo" class="t-center" @click="sortByRiskLevel()" :class="{'is-sorted' : searchForm.sortKey.isSortedByRiskLevel, 'is-descending' : (searchForm.sortKey.isSortedByRiskLevel && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByRiskLevel && searchForm.sortKey.isAscendingSort ) }">
                <span>リスク</span>
              </th>
              <th v-if="isIpo" class="t-center" @click="sortByIpoLevel()" :class="{'is-sorted' : searchForm.sortKey.isSortedByIpoLevel, 'is-descending' : (searchForm.sortKey.isSortedByIpoLevel && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByIpoLevel && searchForm.sortKey.isAscendingSort ) }">
                <span>IPO重要度</span>
              </th>
              <th class="t-center" @click="sortByDueDate()" :class="{'is-sorted' : searchForm.sortKey.isSortedByDueDate, 'is-descending' : (searchForm.sortKey.isSortedByDueDate && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByDueDate && searchForm.sortKey.isAscendingSort ) }">
                <span>対応期限</span>
              </th>
              <th class="t-center" @click="sortByUpdatedDate()" :class="{'is-sorted' : searchForm.sortKey.isSortedByUpdatedDate, 'is-descending' : (searchForm.sortKey.isSortedByUpdatedDate && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByUpdatedDate && searchForm.sortKey.isAscendingSort ) }">
                <span>更新日時</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diagResultItem in diagResultItemList" :key="diagResultItem.diagResultItemId">
              <td>
                <input type="checkbox"
                  class="target-checkbox" style="z-index: 2;"
                  :value="diagResultItem.diagResultItemId"
                  v-model="bulkUpdateForm.diagResultItemIds" />
              </td>
              <td @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <p class="number-text">
                  <span class="number">{{ diagResultItem.sectionSortOrder }}-{{ diagResultItem.subSectionSortOrder }}-{{ diagResultItem.diagItemSortOrder }}</span>
                  <span class="text" style="white-space: pre-line;">{{ diagResultItem.checkItem }}</span>
                </p>
              </td>
              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                {{ diagResultItem.sectionNm }}</td>
              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">{{ diagResultItem.answerText }}</td>
              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <span v-if="diagResultItem.verifiedByLaborConsultant">済</span>
                <span v-else>-</span>
              </td>
              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <span v-if="diagResultItem.isHighPriority">高</span>
                <span v-else>-</span>
              </td>

              <td v-if="!isIpo" class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <span class="label" :class="diagResultItem.riskLevelDisplayLabelClass" :data-tooltip="diagResultItem.riskLevelDescription" @mouseover="toggle(diagResultItem)" @mouseleave="toggleb(diagResultItem)">
                  <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.riskLevelDescription}}</span>
                  {{ diagResultItem.riskLevelName }}
                </span>
              </td>
              <td v-if="isIpo" class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <span class="label-level" :class="diagResultItem.ipoLevelDisplayLabelClass" :data-tooltip="diagResultItem.ipoLevelDescription" @mouseover="toggle(diagResultItem)" @mouseleave="toggleb(diagResultItem)">
                  <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.ipoLevelDescription}}</span>
                  {{ diagResultItem.ipoLevelName }}
                </span>
              </td>


              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                <template v-if="diagResultItem.itemVal == 2 || diagResultItem.itemVal == 3">
                  <span v-if="diagResultItem.dueDate">{{ $dayjs(diagResultItem.dueDate).format("YYYY/MM/DD") }}</span>
                  <span v-else>未設定</span>
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="t-center" @click="goDiagManagementDetail(diagResultItem.diagResultItemId)">
                  <span v-if="diagResultItem.updatedDate">{{ $dayjs(diagResultItem.updatedDate).format("YYYY/MM/DD HH:mm") }}</span>
                  <span v-else>未設定</span>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
    <transition name="tutorialmodal-fade">
      <DiagManagementTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="showTutorialModal(false)"
      ></DiagManagementTutorial>
    </transition>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import constant from '@/const';
import Pagination from '@/components/parts/common/Pagination.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import { required } from 'vuelidate/lib/validators';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import DiagManagementTutorial from '@/components/parts/tutorial/DiagManagementTutorial.vue';

export default {
  components: {
    Loading,
    Pagination,
    DiagCorpHeader,
    DiagHeaderNavigation,
    DiagNavigation,
    DiagManagementTutorial,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isShowTutorial: false,
      isSearch: false,
      pageInfo: {
        currentPage: 1,
        lastPage: 1,
        total: 1,
        from: 0,
        to: 0
      },
      perPage: 50,
      searchForm: {
        selectedDiagSectionIds: [],
        selectedItemVals: ['2', '3'],
        selectedVerifiedByLaborConsultant: [false, true],
        selectedRiskLevelIds: [],
        selectedIpoLevelIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        },
      },
      bulkUpdateForm: {
        diagResultItemIds: [],
        verifiedByLaborConsultant: false,
        isHighPriority: false,
        isAllChecked: false,
        bulkUpdateMode: ''
      },
      diagResultItemList: [],
      diagSectionListForSearch: [],
      score: 0,
      totalScore: 0,
      itemValList: constant.DIAG_ANSWER_VALUE,
      verifiedByLaborConsultantList: constant.VERIFIED_BY_LABOR_CONSULTANT,
      riskLevelList: [],
      ipoImportanceList: [],
      bulkUpdateModeList: constant.DIAG_MANAGEMENT_BULK_UPDATE_MODE,
      isIpo:false,
    }
  },
  validations: {
    bulkUpdateForm: {
      bulkUpdateMode: { required }
    }
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    selectedDiagResultItemCount() {
      return this.bulkUpdateForm.diagResultItemIds.length;
    },
    selectedRiskLevelLabel() {
      if (this.searchForm.selectedRiskLevelIds.length == 0) {
        return '設定無し';
      }
      let riskLevelList = this.riskLevelList;
      let selectedRiskLevels = [];
      this.searchForm.selectedRiskLevelIds.forEach(riskLevelId => {
        let selectedRiskLevel = riskLevelList.find(riskLevel => riskLevel.riskLevelId === riskLevelId);
        selectedRiskLevels.push(selectedRiskLevel.name);
      }, riskLevelList)
      return selectedRiskLevels.join(',');
    },
    selectedIpoLevelLabel() {
      if (this.searchForm.selectedIpoLevelIds.length == 0) {
        return '設定無し';
      }
      let ipoImportanceList = this.ipoImportanceList;
      let selectedIpoLevels = [];
      this.searchForm.selectedIpoLevelIds.forEach(ipoImportanceId => {
        let selectedIpoLevel = ipoImportanceList.find(ipoImportance => ipoImportance.ipoImportanceId === ipoImportanceId);
        selectedIpoLevels.push(selectedIpoLevel.name);
      }, ipoImportanceList)
      return selectedIpoLevels.join(',');
    },
    selectedItemValsLabel() {
      if (this.searchForm.selectedItemVals.length == 0) {
        return '設定無し';
      }
      let itemValList = this.itemValList;
      let selectedItemVals = [];
      this.searchForm.selectedItemVals.forEach(itemVal => {
        let selectedItemVal = itemValList.find(iv => iv.value === itemVal);
        selectedItemVals.push(selectedItemVal.label);
      }, itemValList)
      return selectedItemVals.join(',');
    },
    selectedVerifiedByLaborConsultantLabel() {
      if (this.searchForm.selectedVerifiedByLaborConsultant.length == 0) {
        return '設定無し';
      }
      let verifiedByLaborConsultantList = this.verifiedByLaborConsultantList;
      let selectedVerifiedByLaborConsultantList = [];
      this.searchForm.selectedVerifiedByLaborConsultant.forEach(verifiedByLaborConsultant => {
        let selectedVerifiedByLaborConsultant = verifiedByLaborConsultantList.find(vblc => vblc.value === verifiedByLaborConsultant);
        selectedVerifiedByLaborConsultantList.push(selectedVerifiedByLaborConsultant.label);
      }, verifiedByLaborConsultantList)
      return selectedVerifiedByLaborConsultantList.join(',');
    },
    selectedDiagSectionLabel() {
      if (this.searchForm.selectedDiagSectionIds.length == 0) {
        return '設定無し';
      }
      let diagSectionList = this.diagSectionListForSearch;
      let selectedDiagSectionList = [];
      this.searchForm.selectedDiagSectionIds.forEach(diagSectionId => {
        let selectedDiagSection = diagSectionList.find(ds => ds.sectionId == diagSectionId);
        selectedDiagSectionList.push(selectedDiagSection.label);
      }, diagSectionList)
      return selectedDiagSectionList.join(',');
    },
  },
  watch: {
    async corpId() {
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$router.push({ name: 'diag-top' });
    },
  },
  created: async function () {
    this.isProcessing = true;
    this.isRendering = true;
    this.searchForm = this.$store.getters['diag/getDiagManagementListSearchForm'];
    await this.getDiagManagementList(this.diagResultId, 1)
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;
    });
    this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowDiagManagementTutorial);
  },
  methods: {
    toggle(elm) {
      var id = elm.diagResultItemId;
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(elm) {
      var id = elm.diagResultItemId;
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    showSearch(value) {
      this.isSearch = value;
    },
    emitChangePage(page) {
      this.getDiagManagementList(this.diagResultId, page)
    },
    onChangePerPage() {
      this.getDiagManagementList(this.diagResultId, 1);
    },
    async renderDiagManagementList(diagResultId, page) {
      this.isProcessing = true;
      this.isRendering = true;
      await this.getDiagManagementList(diagResultId, page);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    async getDiagManagementList(diagResultId, page) {
      let res = await this.$axios.post('/ld/api/diag/getDiagManagementList', {
        page: page,
        perPage: this.perPage,
        diagResultId: diagResultId,
        selectedDiagSectionIds: this.searchForm.selectedDiagSectionIds,
        selectedItemVals: this.searchForm.selectedItemVals,
        selectedVerifiedByLaborConsultant: this.searchForm.selectedVerifiedByLaborConsultant,
        selectedRiskLevelIds: this.searchForm.selectedRiskLevelIds,
        selectedIpoLevelIds: this.searchForm.selectedIpoLevelIds,
        sortKey: this.searchForm.sortKey,
        corpId: this.corpId,
      });
      if (res.status === 200) {
        this.diagResultItemList = res.data.diagResultItemList.data;
        this.riskLevelList = res.data.riskLevelList;
        this.ipoImportanceList = res.data.ipoImportanceList;

        res.data.diagSectionListForSearch.forEach(diagSection => {
          if (!this.diagSectionListForSearch.some(section => section.sectionId === diagSection.sectionId)) {
            this.diagSectionListForSearch.push(diagSection);
          }
        });
        this.diagResult = res.data.diagResult;
        this.isIpo = res.data.isIpo;

        this.score = res.data.diagResultScore.answeredCount;
        this.totalScore = res.data.diagResultScore.totalCount;

//        this.score = res.data.diagResult.score;
//        this.totalScore = res.data.diagResult.totalScore;

        this.pageInfo = {
          currentPage: res.data.diagResultItemList.current_page,
          lastPage: res.data.diagResultItemList.last_page,
          total: res.data.diagResultItemList.total,
          from: res.data.diagResultItemList.from,
          to: res.data.diagResultItemList.to,
        };
        this.bulkUpdateForm.diagResultItemIds = [];
        this.isSearch = false;
      } else {
        this.$toast.error(res.data.message);
      }
    },
    async search() {
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async execBulkUpdate() {
      this.$v.bulkUpdateForm.$touch();
      if (this.bulkUpdateForm.diagResultItemIds.length == 0) {
        this.$toast.error('処理対象の項目を選択してください。');
        this.bulkUpdateForm.bulkUpdateMode = "";
        return;
      }
      if (this.$v.bulkUpdateForm.$invalid) return;

      const answer = window.confirm("変更しますか？")
      if (!answer) {
        return;
      }
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/bulkUpdateDiagResultItemForLaborConsultant', {
        diagResultId: this.diagResultId,
        diagResultItemIds: this.bulkUpdateForm.diagResultItemIds,
        bulkUpdateMode: this.bulkUpdateForm.bulkUpdateMode,
        corpId: this.corpId,
      });
      if (res.status === 200) {
        let mode = this.bulkUpdateModeList.find(m => m.value == this.bulkUpdateForm.bulkUpdateMode);
        this.$toast.info(mode.label + 'しました。');
        this.score = res.data.diagResult.score;
        this.totalScore = res.data.diagResult.totalScore;
        this.bulkUpdateForm.bulkUpdateMode = "";
        this.bulkUpdateForm.isAllChecked = false;
        await this.renderDiagManagementList(this.diagResultId, 1);

      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    goDiagManagementDetail(diagResultItemId) {
      this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
      this.$store.dispatch('diag/setDiagManagementListSearchForm', this.searchForm);

      this.$router.replace({path: '/diag/management/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/management/detailparam'});
//      this.$router.push({ name: 'diag-management-detail' });
    },
    goDiagSectionList() {
      this.$store.dispatch('diag/setDiagResultId', this.diagResultId);
      this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.diagCourseId } });
    },
    goDiagList() {
      this.$store.dispatch('diag/setCorpId', this.corpId);
      this.$router.push({ name: 'diag-top' });
    },
    goTaskList() {
      this.$router.push({ name: 'task-list' });
    },
    changeIsAllChecked(value) {
      this.bulkUpdateForm.isAllChecked = value;
      if (this.bulkUpdateForm.isAllChecked) {
        this.bulkUpdateForm.diagResultItemIds = this.diagResultItemList.map(diagResultItem => diagResultItem.diagResultItemId);
      } else {
        this.bulkUpdateForm.diagResultItemIds = [];
      }
    },
    async sortByCheckItem() {
      if (this.searchForm.sortKey.isSortedByCheckItem) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  true,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByDiagSection() {
      if (this.searchForm.sortKey.isSortedByDiagSection) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: true,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByAnswer() {
      if (this.searchForm.sortKey.isSortedByAnswer) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: true,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByVerifiedByLaborConsultant() {
      if (this.searchForm.sortKey.isSortedByVerifiedByLaborConsultant) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: true,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByIsHighPriority() {
      if (this.searchForm.sortKey.isSortedByIsHighPriority) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: true,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByRiskLevel() {
      if (this.searchForm.sortKey.isSortedByRiskLevel) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: true,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByIpoLevel() {
      if (this.searchForm.sortKey.isSortedByIpoLevel) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: true,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },
    async sortByDueDate() {
      if (this.searchForm.sortKey.isSortedByDueDate) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: true,
          isSortedByUpdatedDate: false,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },

    async sortByUpdatedDate() {
      if (this.searchForm.sortKey.isSortedByUpdatedDate) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByDueDate: false,
          isSortedByUpdatedDate: true,
          isAscendingSort: false,
        };
      }
      await this.renderDiagManagementList(this.diagResultId, 1);
    },

    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    }
  },
}

</script>

<style scoped>
.diagmanagesearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.diagmanagesearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.diagmanagesearch-fade-enter-to, .diagmanagesearch-fade-leave {
   overflow: hidden;
}
.diagmanagesearch-fade-enter, .diagmanagesearch-fade-leave-to {
   overflow: hidden;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
